import { useSelector } from 'react-redux';
import {
  getIsInExclusivePreview,
  getIsReservableVehicle,
  getRecalls
} from '~/selectors';

export default function useShouldImport() {
  const isInExclusivePreview = useSelector(getIsInExclusivePreview) || false;
  const isReservable = useSelector(getIsReservableVehicle);
  const recalls = useSelector(getRecalls);

  const importRecalls = recalls.length > 0;
  const importReservableHeader = isReservable || isInExclusivePreview;

  return {
    importRecalls,
    importReservableHeader
  };
}
